import PageWrapper from "Components/Pages/Wrapper";
import styled from "styled-components";

export const SelectTitle = styled.h2`
  color: var(--color-purple);
  font-size: 18px;
  font-weight: 400;
  line-height: 25px;
`;

export const PageContainer = styled(PageWrapper)`
  box-sizing: border-box;

  &.app-content .content-holder .page-heading {
    z-index: 0;
  }

  @media (min-width: 1260px) {
    &.app-content .content-holder {
      padding-top: 0;
      padding-bottom: 0px;
      height: 100%;
    }
  }
`;

export const PageContent = styled.div`
  flex: 1;
  height: 100%;
  display: grid;
  grid-template-rows: 132px 1fr;
  grid-template-columns: 1fr 350px;
  padding-bottom: 2px !important;

  &.full-w-page {
    grid-template-columns: 1fr;
  }

  @media (min-width: 1600px) {
    grid-template-columns: 1fr 500px;
  }
`;

export const PageMain = styled.div`
  padding: 0;
  grid-row: 2/3;
  grid-column: 1/2;
  border-right: 1px solid #c4c4c4;
  box-sizing: border-box;
  width: 100%;
  background: #f5f5f5;
  padding: 0 5px;

  .tabs {
    display: flex;

    button {
      border-radius: 5px;
      font-weight: 600;

      &:hover {
        background: var(--color-purple);
        color: white;
      }
    }
  }
  .documents {
    margin-top: 30px;

    .documents-preview {
      overflow: hidden;
    }
  }

  .title-search-products-budget {
    margin-top: 20px;
  }

  .card-search-information {
    padding-right: 20px;
    padding-left: 20px;

    grid-column: 1/2;
    grid-row: 2/3;
    margin: 0;
  }

  h3,
  h5 {
    color: var(--color-purple);
  }

  .cart-flex-products {
    display: flex;
    flex-direction: column;
    margin-top: 20px;

    &.blocked {
      button {
        pointer-events: none;
      }
    }
  }
`;

export const PageHeading = styled.div`
  grid-row: 1/2;
  grid-column: 1/2;
  width: auto;
  padding:0 5px;
  border-right: 1px solid #c4c4c4;


  h5 {
    font-family: var(--font-display);
    font-size: 15px;
    font-weight: 500;
    color: var(--color-gray-text);
    line-height: 22px;
  }

  p {
    font-family: var(--font-display);
    color: var(--color-purple);
    font-weight: 500;
    font-size: 13px;
    line-height: 19px;
    font-weight: 600;
  
`;

export const CartStyles = styled.div`
  grid-column: 2/3;
  grid-row: 1/3;
  border-top: none;
  padding: 20px 10px;
  position: unset;
  width: auto;
  scroll: auto;

  .budget-collect-type {
    display: flex;
    align-items: center;
    gap: 1rem;

    .collect-title {
      color: var(--color-purple);
      margin-bottom: 0;

      & strong {
        font-weight: 600;
      }
    }

    .color-purple {
      color: var(--color-purple);
    }
  }

  .blocked {
    button {
      pointer-events: none;
    }
  }

  .cart-item .action {
    width: 210px;
    justify-content: space-between;
  }

  .product-quantity {
    font-family: var(--font-display);
    padding: 0 10px;
  }

  .unit-selected {
    padding-top: 10px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    font-size: 14px;
    border-top: 1px solid #e5e5e5;

    p {
      font-family: var(--font-display);
      line-height: 22px;
      max-width: 155px;
      color: #666666;
    }

    .unit-name {
      word-wrap: break-word;
    }
  }
`;
